<template>
    <v-card>
        <div class="loader-container">
            <div class="loader" v-show="ticketsLoading">
                <svg class="circular">
                    <circle class="path" cx="24" cy="24" r="20" fill="none" stroke-width="4"
                            stroke-miterlimit="10"></circle>
                </svg>
            </div>

        </div>
        <v-card-title>
            <v-icon color="primary" class="mr-2">local_activity</v-icon>
            <span class="title primary--text">Tickets</span>
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="items"
                      item-key="unique"
                      hide-actions
        >
            <template v-slot:no-data>
                Keine Tickets ausgewählt
            </template>
            <template v-slot:items="props">
                <td>{{props.item.ticketName}}</td>
                <td class="text-xs-right">{{ props.item.price }}</td>
            </template>
            <template v-slot:footer>
                <tr v-if="_.get(priceDetails, 'discount')" v-show="!_.isEmpty(items)">
                    <td>Rabatt</td>
                    <td class="text-xs-right">
                        {{_.get(priceDetails, 'discount')}}
                    </td>
                </tr>
                <tr class="price-details-footer" v-show="!_.isEmpty(items)">
                    <td>
                        <strong>Gesamtsumme</strong>
                    </td>
                    <td class="text-xs-right">
                        <strong>{{_.get(priceDetails, 'totalBrutto')}}</strong>
                    </td>
                </tr>
                <tr v-show="!_.isEmpty(items) && _.get(priceDetails, 'taxRate')>0">
                    <td>
                        Inkl. MwSt ({{_.get(priceDetails, 'taxRate')}} %)
                    </td>
                    <td class="text-xs-right">
                        {{_.get(priceDetails, 'totalTax')}}
                    </td>
                </tr>
                <tr v-show="!_.isEmpty(items)">
                    <td>
                        Nettosumme
                    </td>
                    <td class="text-xs-right">
                        {{_.get(priceDetails, 'totalNetto')}}
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "PriceBox",
        props: {},
        data() {
            return {
                headers: [
                    {
                        text: 'Ticket',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {
                        text: 'Preis',
                        value: 'rendered_price',
                        align: 'center',
                        sortable: false,
                    },
                ],
            }
        },
        computed: {
            ...mapState('form', [
                    'ticketsLoading',
                    'priceDetails',
                ]
            ),
            items() {
                return _.map(_.get(this.priceDetails, 'items'), function (value, idx) {
                    Vue.set(value, 'unique', idx);
                    return value;
                })
            }
        }
    }
</script>

<style scoped>

</style>
